var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('a-spin',{attrs:{"size":"large","spinning":this.$store.state.loadding,"tip":"拼命加载数据中..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }